import { CheckCircleOutline, ErrorOutline, Logout } from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

export type CheckInResultVariant = "loading" | "success" | "checkout" | "error";

export interface CheckInResultProps {
  variant: CheckInResultVariant;
  title: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function CheckInResult({ variant, title, message, actionLabel, onAction }: CheckInResultProps) {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        justifyContent: "center",
        minHeight: 280,
        p: 3,
        textAlign: "center",
      }}
    >
      {variant === "loading" ? <CircularProgress size={48} /> : null}
      {variant === "success" ? <CheckCircleOutline color="success" sx={{ fontSize: 56 }} /> : null}
      {variant === "checkout" ? <Logout color="primary" sx={{ fontSize: 56 }} /> : null}
      {variant === "error" ? <ErrorOutline color="error" sx={{ fontSize: 56 }} /> : null}
      <Typography component="h1" variant="h5">
        {title}
      </Typography>
      {message ? (
        <Typography color="text.secondary" sx={{ maxWidth: 420 }} variant="body1">
          {message}
        </Typography>
      ) : null}
      {actionLabel && onAction ? (
        <Button onClick={onAction} sx={{ mt: 1 }} variant="contained">
          {actionLabel}
        </Button>
      ) : null}
    </Box>
  );
}
